// import React, { useState, useEffect, useRef } from 'react';
// import './artisanmessages.scss';
// import withAuth from '../../auth/WithAuth';
// import FurnitureNavbar from '../../../components/layout/Nav';
// import { serverUrlAuth } from '../../../serverUrl';
// import { toast } from 'react-toastify';
// import {
//   FaSearch,
//   FaUserCircle,
//   FaComments,
//   FaPaperPlane,
//   FaArrowLeft,
//   FaClock,
//   FaImage,
//   FaCheck,
//   FaHandshake,
//   FaMoneyBillWave,
//   FaTimes,
//   FaFlag,
//   FaEdit,
// } from 'react-icons/fa';
// import { useLocation } from 'react-router-dom';
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';

// const ArtisanMessages = () => {
//   const location = useLocation();
 
//   const queryParams = new URLSearchParams(location.search);
//   const preselectedProposalId = queryParams.get('proposal');

//   const [conversations, setConversations] = useState([]);
//   const [selectedConversation, setSelectedConversation] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [loadingMessages, setLoadingMessages] = useState(false);
//   const [isSending, setIsSending] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showSidebar, setShowSidebar] = useState(true);
//   const [negotiationDetails, setNegotiationDetails] = useState(null);
//   const [isArtisanSelected, setIsArtisanSelected] = useState(false);
//   const [currentProjectId, setCurrentProjectId] = useState(null);

//   const [messageType, setMessageType] = useState('chat');
//   const [progressPercentage, setProgressPercentage] = useState('');
//   const [milestoneNote, setMilestoneNote] = useState('');

//   const [selectedImages, setSelectedImages] = useState([]);
//   const [imagePreviewUrls, setImagePreviewUrls] = useState([]);
//   const fileInputRef = useRef(null);

//   const [showFinalAgreementModal, setShowFinalAgreementModal] = useState(false);
//   const [finalAgreementAmount, setFinalAgreementAmount] = useState('');
//   const [isSubmittingFinalAgreement, setIsSubmittingFinalAgreement] =
//     useState(false);

//   const [showEditFinalAgreementModal, setShowEditFinalAgreementModal] =
//     useState(false);
//   const [editFinalAgreementAmount, setEditFinalAgreementAmount] = useState('');
//   const [isEditingFinalAgreement, setIsEditingFinalAgreement] = useState(false);
//   const [editAgreementNote, setEditAgreementNote] = useState('');

//   const [showImageViewer, setShowImageViewer] = useState(false);
//   const [selectedImageForView, setSelectedImageForView] = useState(null);

//   const messagesEndRef = useRef(null);
//   const messageIntervalRef = useRef(null);
//   const messagesContainerRef = useRef(null);
//   const isPollingRef = useRef(false);

//   const markMessagesAsRead = async (projectId) => {
//     if (!projectId) return;
//     try {
//       await serverUrlAuth.post(
//         `/updates/mark-messages-as-read/${projectId}/mark-all-read/`,
//       );
//       const convResponse = await serverUrlAuth.get('negotiations/inbox/');
//       setConversations(convResponse.data);
//     } catch (err) {
//       console.error('Error marking messages as read:', err);
//     }
//   };

//   const fetchProposalDetails = async (proposalId) => {
//     try {
//       const response = await serverUrlAuth.get(
//         `proposals/proposal-detail/${proposalId}/`,
//       );
//       return response.data;
//     } catch (err) {
//       console.error('Error fetching proposal details:', err);
//       return null;
//     }
//   };

//   const handleEditFinalAgreement = async () => {
//     if (!editFinalAgreementAmount || editFinalAgreementAmount <= 0) {
//       toast.error('Please enter a valid amount');
//       return;
//     }

//     setIsEditingFinalAgreement(true);
//     try {
//       await serverUrlAuth.patch(
//         `negotiations/submit-final-agreement/${negotiationDetails.id}/`,
//         {
//           final_agreed_amount: editFinalAgreementAmount,
//         },
//       );

//       toast.success('Final agreement amount updated successfully!');
//       setShowEditFinalAgreementModal(false);
//       setEditFinalAgreementAmount('');
//       setEditAgreementNote('');

//       await fetchNegotiationDetails(selectedConversation.proposal);

//       if (editAgreementNote.trim()) {
//         await serverUrlAuth.post(
//           `negotiations/proposal/${selectedConversation?.proposal}/messages/`,
//           {
//             message: `📝 Note about updated agreement: ${editAgreementNote}`,
//           },
//         );
//       }

//       await fetchMessages(currentProjectId);
//     } catch (err) {
//       console.error('Error updating final agreement:', err);
//       toast.error('Failed to update final agreement');
//     } finally {
//       setIsEditingFinalAgreement(false);
//     }
//   };

//   const fetchProjectStatus = async (projectId) => {
//     if (!projectId) return false;
//     try {
//       const response = await serverUrlAuth.get(
//         `projects/artisan-project/${projectId}/`,
//       );
//       if (response.data) {
//         const isSelected =
//           response.data.status === 'in-progress' ||
//           response.data.status === 'completed';
//         setIsArtisanSelected(isSelected);
//         return isSelected;
//       }
//       return false;
//     } catch (err) {
//       console.error('Error fetching project status:', err);
//       return false;
//     }
//   };

//   const fetchConversations = async () => {
//     try {
//       const response = await serverUrlAuth.get('negotiations/inbox/');
//       setConversations(response.data);

//       if (preselectedProposalId && !selectedConversation) {
//         let conversation = response.data.find(
//           (c) => c.proposal?.toString() === preselectedProposalId,
//         );

//         if (conversation) {
//           const projectId = conversation.proposal_details?.project;
//           setCurrentProjectId(projectId);
//           setSelectedConversation(conversation);
//           setShowSidebar(false);

//           await fetchProposalDetails(conversation.proposal);
//           await fetchProjectStatus(projectId);
//           await fetchNegotiationDetails(conversation.proposal);
//           await fetchMessages(projectId);
//           await markMessagesAsRead(projectId);
//         } else {
//           await fetchSingleConversation(preselectedProposalId);
//         }
//       }
//     } catch (err) {
//       console.error('Error fetching conversations:', err);
//       toast.error('Failed to load conversations');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchSingleConversation = async (proposalId) => {
//     try {
//       const response = await serverUrlAuth.get(
//         `negotiations/proposal/${proposalId}/`,
//       );
//       const convData = response.data;
//       const projectId = convData.proposal_details?.project;

//       const newConversation = {
//         id: convData.id,
//         proposal: proposalId,
//         project_id: projectId,
//         project_title: convData.project_title,
//         artisan_name: convData.artisan_name,
//         client_name: convData.client_name,
//         last_message_time: convData.created_at,
//         unread_count: 0,
//       };

//       setCurrentProjectId(projectId);
//       setSelectedConversation(newConversation);
//       setShowSidebar(false);
//       setNegotiationDetails(convData);

//       await fetchProposalDetails(proposalId);
//       await fetchProjectStatus(projectId);
//       await fetchMessages(projectId);
//       await markMessagesAsRead(projectId);
//     } catch (err) {
//       console.error('Error fetching single conversation:', err);
//       toast.error('Could not open conversation');
//     }
//   };

//   const fetchMessages = async (projectId, isPolling = false) => {
//     if (!projectId) return;

//     if (!isPolling) setLoadingMessages(true);
//     try {
//       const response = await serverUrlAuth.get(
//         `/updates/messages/${projectId}/`,
//       );
//       setMessages(response.data);
//       scrollToBottom();
//     } catch (err) {
//       console.error('Error fetching messages:', err);
//     } finally {
//       if (!isPolling) setLoadingMessages(false);
//     }
//   };

//   const fetchNegotiationDetails = async (proposalId) => {
//     try {
//       const response = await serverUrlAuth.get(
//         `negotiations/proposal/${proposalId}/`,
//       );
//       setNegotiationDetails(response.data);
//     } catch (err) {
//       console.error('Error fetching negotiation details:', err);
//     }
//   };

//   const handleImageSelect = (e) => {
//     const files = Array.from(e.target.files);
//     const validFiles = files.filter((file) => file.type.startsWith('image/'));
//     const newImages = [...selectedImages, ...validFiles];
//     const newPreviews = [
//       ...imagePreviewUrls,
//       ...validFiles.map((file) => URL.createObjectURL(file)),
//     ];
//     setSelectedImages(newImages);
//     setImagePreviewUrls(newPreviews);
//   };

//   const removeSelectedImage = (index) => {
//     URL.revokeObjectURL(imagePreviewUrls[index]);
//     setSelectedImages(selectedImages.filter((_, i) => i !== index));
//     setImagePreviewUrls(imagePreviewUrls.filter((_, i) => i !== index));
//   };

//   const clearImages = () => {
//     imagePreviewUrls.forEach((url) => URL.revokeObjectURL(url));
//     setSelectedImages([]);
//     setImagePreviewUrls([]);
//   };

//   // ✅ Updated sendMessage with 100% completion notification
//   const sendMessage = async () => {
//     if (isArtisanSelected) {
//       if (messageType === 'milestone') {
//         if (!milestoneNote.trim()) {
//           toast.error('Please add a note for the milestone');
//           return;
//         }
//         if (
//           !progressPercentage ||
//           progressPercentage < 0 ||
//           progressPercentage > 100
//         ) {
//           toast.error('Please enter a valid progress percentage (0-100)');
//           return;
//         }
//       } else {
//         if (!newMessage.trim() && selectedImages.length === 0) {
//           toast.error('Please enter a message or attach an image');
//           return;
//         }
//       }
//     } else {
//       if (!newMessage.trim() && selectedImages.length === 0) return;
//     }

//     setIsSending(true);

//     try {
//       let response;

//       if (isArtisanSelected && currentProjectId) {
//         const formData = new FormData();
//         const isMilestoneComplete =
//           messageType === 'milestone' && parseInt(progressPercentage) === 100;

//         formData.append('type', messageType);

//         if (messageType === 'milestone') {
//           formData.append('progress_percentage', progressPercentage);
//           formData.append('note', milestoneNote);
//         } else {
//           formData.append('message', newMessage.trim() || '📷 Image attached');
//         }

//         selectedImages.forEach((image) => {
//           formData.append('uploaded_images', image);
//         });

//         // Send the milestone/update
//         response = await serverUrlAuth.post(
//           `/updates/post-updates/${currentProjectId}/`,
//           formData,
//           {
//             headers: { 'Content-Type': 'multipart/form-data' },
//           },
//         );

//         // ✅ If milestone is 100%, send a separate payment notification
//         if (isMilestoneComplete) {
//           // Get the agreed amount from negotiation details
         

//           const paymentMessage = `🎉 Your product is ready. To proceed with delivery, kindly complete the final payment. Delivery will begin as soon as your payment is confirmed.`;
         

//           // Send payment notification as a separate message
//           await serverUrlAuth.post(
//             `/updates/post-updates/${currentProjectId}/`,
//             {
//               type: 'chat',
//               message: paymentMessage,
//             },
//             {
//               headers: { 'Content-Type': 'application/json' },
//             },
//           );

//           toast.success(
//             '🎉 Project marked as complete! Payment notification sent to client.',
//           );
//         }

//         setProgressPercentage('');
//         setMilestoneNote('');
//       } else {
//         const formData = new FormData();
//         formData.append('message', newMessage.trim() || '📷 Image attached');
//         selectedImages.forEach((image) => {
//           formData.append('images', image);
//         });

//         response = await serverUrlAuth.post(
//           `negotiations/proposal/${selectedConversation.proposal}/messages/`,
//           formData,
//           { headers: { 'Content-Type': 'multipart/form-data' } },
//         );
//       }

//       if (response.data) {
//         setMessages((prev) => [...prev, response.data]);
//         setNewMessage('');
//         clearImages();
//         scrollToBottom();

//         const convResponse = await serverUrlAuth.get('negotiations/inbox/');
//         setConversations(convResponse.data);
//       }
//     } catch (err) {
//       console.error('Failed to send message:', err);
//       toast.error('Failed to send message.');
//     } finally {
//       setIsSending(false);
//     }
//   };

//   const handleSubmitFinalAgreement = async () => {
//     if (!finalAgreementAmount || !selectedConversation || !negotiationDetails)
//       return;

//     setIsSubmittingFinalAgreement(true);
//     try {
//       await serverUrlAuth.patch(
//         `negotiations/submit-final-agreement/${negotiationDetails.id}/`,
//         {
//           final_agreed_amount: finalAgreementAmount,
//         },
//       );

//       toast.success(
//         `Final agreement submitted! Waiting for client acceptance.`,
//       );
//       setShowFinalAgreementModal(false);
//       setFinalAgreementAmount('');
//       await fetchNegotiationDetails(selectedConversation.proposal);
//       await fetchMessages(currentProjectId);
//     } catch (err) {
//       console.error('Error submitting final agreement:', err);
//       toast.error('Failed to submit final agreement');
//     } finally {
//       setIsSubmittingFinalAgreement(false);
//     }
//   };

//   const handleSelectConversation = async (conversation) => {
//     const projectId = conversation.proposal_details?.project;
//     setCurrentProjectId(projectId);
//     setSelectedConversation(conversation);

//     await fetchProposalDetails(conversation.proposal);
//     await fetchProjectStatus(projectId);
//     await fetchNegotiationDetails(conversation.proposal);
//     await fetchMessages(projectId);
//     await markMessagesAsRead(projectId);
//     setShowSidebar(false);
//   };

//   const scrollToBottom = () => {
//     setTimeout(() => {
//       if (messagesContainerRef.current) {
//         messagesContainerRef.current.scrollTop =
//           messagesContainerRef.current.scrollHeight;
//       }
//     }, 100);
//   };

//   const startPolling = () => {
//     if (messageIntervalRef.current) clearInterval(messageIntervalRef.current);

//     messageIntervalRef.current = setInterval(async () => {
//       if (selectedConversation && currentProjectId && !isPollingRef.current) {
//         isPollingRef.current = true;
//         try {
//           await fetchMessages(currentProjectId, true);
//           const convResponse = await serverUrlAuth.get('negotiations/inbox/');
//           setConversations(convResponse.data);
//           scrollToBottom();
//         } catch (error) {
//           console.error('Polling error:', error);
//         } finally {
//           isPollingRef.current = false;
//         }
//       }
//     }, 5000);
//   };

//   const stopPolling = () => {
//     if (messageIntervalRef.current) {
//       clearInterval(messageIntervalRef.current);
//       messageIntervalRef.current = null;
//     }
//   };

//   const filteredConversations = conversations.filter(
//     (conv) =>
//       conv.client_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       conv.project_title?.toLowerCase().includes(searchTerm.toLowerCase()),
//   );

//   const formatTime = (timestamp) => {
//     if (!timestamp) return '';
//     const date = new Date(timestamp);
//     const now = new Date();
//     const diff = now - date;
//     const hours = Math.floor(diff / (1000 * 60 * 60));

//     if (hours < 1) {
//       const mins = Math.floor(diff / (1000 * 60));
//       return mins === 0 ? 'Just now' : `${mins} min ago`;
//     } else if (hours < 24) {
//       return date.toLocaleTimeString([], {
//         hour: '2-digit',
//         minute: '2-digit',
//       });
//     } else if (hours < 48) {
//       return 'Yesterday';
//     } else {
//       return date.toLocaleDateString();
//     }
//   };

//   const formatMessageTime = (timestamp) => {
//     const date = new Date(timestamp);
//     return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//   };

//   const getUnreadCount = (conversation) => conversation.unread_count || 0;
//   const getDisplayName = (conversation) => conversation.client_name;

//   useEffect(() => {
//     fetchConversations();
//     return () => stopPolling();
//   }, []);

//   useEffect(() => {
//     if (selectedConversation && currentProjectId) {
//       startPolling();
//     } else {
//       stopPolling();
//     }
//     return () => stopPolling();
//   }, [selectedConversation, currentProjectId]);

//   useEffect(() => {
//     return () => {
//       imagePreviewUrls.forEach((url) => URL.revokeObjectURL(url));
//     };
//   }, [imagePreviewUrls]);

//   const hasPendingAgreement =
//     negotiationDetails?.pending_final_amount &&
//     !negotiationDetails?.final_agreed_amount;
//   const isChatDisabled = negotiationDetails?.is_closed === true;
//   const isNegotiationPhase = !isArtisanSelected && !isChatDisabled;
//   const isMilestoneComplete =
//     messageType === 'milestone' && parseInt(progressPercentage) === 100;

//   if (loading) {
//     return (
//       <div className="modern-dashboard">
//         <div className="dashboard-loader">
//           <div className="wooden-spinner"></div>
//           <p>Loading conversations...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="modern-dashboard">
//       <FurnitureNavbar />

//       <div className="messages-container-modern">
//         {/* Sidebar */}
//         <div
//           className={`conversations-sidebar-modern ${showSidebar ? 'open' : 'closed'}`}
//         >
//           <div className="sidebar-header-modern">
//             <div className="search-bar-modern">
//               <FaSearch className="search-icon-modern" />
//               <input
//                 type="text"
//                 placeholder="Search clients..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//             </div>
//           </div>

//           <div className="conversations-list-modern">
//             {filteredConversations.length === 0 ? (
//               <div className="empty-state-modern">
//                 <div className="empty-icon-modern">💬</div>
//                 <h4>No conversations yet</h4>
//                 <p>When clients message you, they'll appear here.</p>
//               </div>
//             ) : (
//               filteredConversations.map((conv) => {
//                 const unreadCount = getUnreadCount(conv);
//                 return (
//                   <div
//                     key={conv.id}
//                     className={`conversation-item-modern ${selectedConversation?.id === conv.id ? 'active' : ''}`}
//                     onClick={() => handleSelectConversation(conv)}
//                   >
//                     <div className="avatar-modern">
//                       <FaUserCircle />
//                     </div>
//                     <div className="conversation-info-modern">
//                       <div className="conversation-header-modern">
//                         <h4>{getDisplayName(conv)}</h4>
//                         <span className="timestamp-modern">
//                           {formatTime(conv.last_message_time)}
//                         </span>
//                       </div>
//                       <div className="conversation-preview-modern">
//                         <p className="project-title-modern">
//                           {conv.project_title}
//                         </p>
//                       </div>
//                     </div>
//                     {unreadCount > 0 && (
//                       <div className="unread-badge-modern">{unreadCount}</div>
//                     )}
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>

//         {/* Main Chat Area */}
//         <div className="chat-area-modern">
//           {!selectedConversation ? (
//             <div className="no-conversation-selected-modern">
//               <div className="no-chat-icon-modern">
//                 <FaComments />
//               </div>
//               <h3>Select a conversation</h3>
//               <p>Choose a chat from the list to start messaging</p>
//               <button
//                 className="back-to-chats-btn-modern"
//                 onClick={() => setShowSidebar(true)}
//               >
//                 Back to Chats
//               </button>
//             </div>
//           ) : (
//             <>
//               <div className="chat-header-modern">
//                 <button
//                   className="back-button-modern"
//                   onClick={() => {
//                     setShowSidebar(true);
//                     setSelectedConversation(null);
//                   }}
//                 >
//                   <FaArrowLeft />
//                 </button>
//                 <div className="chat-user-info-modern">
//                   <div className="user-avatar-modern">
//                     <FaUserCircle />
//                   </div>
//                   <div className="user-details-modern">
//                     <h3>{getDisplayName(selectedConversation)}</h3>
//                     <p className="project-context-modern">
//                       Project: {selectedConversation.project_title}
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* Status Banner */}
//               {isArtisanSelected ? (
//                 <div className="status-banner-modern success">
//                   <FaCheck className="status-icon" />
//                   <span>Project In Progress</span>
//                   <small>
//                     Send updates and milestones to keep the client informed
//                   </small>
//                 </div>
//               ) : (
//                 negotiationDetails && (
//                   <div className="status-banner-modern info">
//                     {negotiationDetails.final_agreed_amount ? (
//                       <>
//                         <FaHandshake />
//                         <span>
//                           Price Agreed: KSh{' '}
//                           {Number(
//                             negotiationDetails.final_agreed_amount,
//                           ).toLocaleString()}
//                         </span>
//                       </>
//                     ) : negotiationDetails.pending_final_amount ? (
//                       <>
//                         <FaMoneyBillWave />
//                         <span>
//                           Pending: KSh{' '}
//                           {Number(
//                             negotiationDetails.pending_final_amount,
//                           ).toLocaleString()}
//                         </span>
//                         <button
//                           className="edit-agreement-btn-modern"
//                           onClick={() => {
//                             setEditFinalAgreementAmount(
//                               negotiationDetails.pending_final_amount,
//                             );
//                             setShowEditFinalAgreementModal(true);
//                           }}
//                         >
//                           <FaEdit /> Edit
//                         </button>
//                       </>
//                     ) : (
//                       <>
//                         <FaComments />
//                         <span>Negotiating - Discuss price with the client</span>
//                       </>
//                     )}
//                   </div>
//                 )
//               )}

//               {/* Messages Area */}
//               <div className="messages-area-modern" ref={messagesContainerRef}>
//                 {loadingMessages && messages.length === 0 ? (
//                   <div className="loading-messages-modern">
//                     <div className="spinner-modern"></div>
//                     <p>Loading messages...</p>
//                   </div>
//                 ) : messages.length === 0 ? (
//                   <div className="no-messages-modern">
//                     <div className="no-messages-icon-modern">💬</div>
//                     <p>No messages yet</p>
//                     <small>Send a message to start the conversation</small>
//                   </div>
//                 ) : (
//                   messages.map((msg, index) => {
//                     const isSent = msg.sender_role === 'artisan';
//                     const isMilestone = msg.type === 'milestone';
//                     const showDate =
//                       index === 0 ||
//                       (messages[index - 1] &&
//                         new Date(
//                           msg.timestamp || msg.created_at,
//                         ).toDateString() !==
//                           new Date(
//                             messages[index - 1].timestamp ||
//                               messages[index - 1].created_at,
//                           ).toDateString());

//                     return (
//                       <React.Fragment key={msg.id}>
//                         {showDate && (
//                           <div className="date-divider-modern">
//                             <span>
//                               {new Date(
//                                 msg.timestamp || msg.created_at,
//                               ).toLocaleDateString(undefined, {
//                                 weekday: 'long',
//                                 year: 'numeric',
//                                 month: 'long',
//                                 day: 'numeric',
//                               })}
//                             </span>
//                           </div>
//                         )}
//                         <div
//                           className={`message-bubble-modern ${isSent ? 'sent' : 'received'}`}
//                         >
//                           <div className="message-content-modern">
//                             {isMilestone ? (
//                               <div className="milestone-update-modern">
//                                 <div className="milestone-header-modern">
//                                   <FaFlag className="milestone-icon-modern" />
//                                   <span className="milestone-label-modern">
//                                     Milestone Update
//                                   </span>
//                                 </div>
//                                 <div className="progress-section-modern">
//                                   <div className="progress-info-modern">
//                                     <span>
//                                       Progress: {msg.progress_percentage}%
//                                     </span>
//                                   </div>
//                                   <div className="progress-bar-container-modern">
//                                     <div
//                                       className="progress-fill-modern"
//                                       style={{
//                                         width: `${msg.progress_percentage}%`,
//                                       }}
//                                     />
//                                   </div>
//                                 </div>
//                                 <div className="milestone-note-modern">
//                                   {msg.note}
//                                 </div>
//                               </div>
//                             ) : (
//                               <p>{msg.message}</p>
//                             )}
//                             {msg.offer && (
//                               <div className="offer-bubble-modern">
//                                 💰 Price Proposal: KSh{' '}
//                                 {Number(msg.offer).toLocaleString()}
//                               </div>
//                             )}
//                             {msg.images && msg.images.length > 0 && (
//                               <div className="message-images-modern">
//                                 {msg.images.map((img, imgIndex) => (
//                                   <img
//                                     key={imgIndex}
//                                     src={img.image_url || img.image}
//                                     alt="Attachment"
//                                     className="message-image-modern"
//                                     onClick={() => {
//                                       setSelectedImageForView(
//                                         img.image_url || img.image,
//                                       );
//                                       setShowImageViewer(true);
//                                     }}
//                                   />
//                                 ))}
//                               </div>
//                             )}
//                           </div>
//                           <div className="message-meta-modern">
//                             <span className="message-time-modern">
//                               {formatMessageTime(
//                                 msg.created_at || msg.timestamp,
//                               )}
//                             </span>
//                           </div>
//                         </div>
//                       </React.Fragment>
//                     );
//                   })
//                 )}
//                 <div ref={messagesEndRef} />
//               </div>

//               {/* Image Preview Area */}
//               {imagePreviewUrls.length > 0 && (
//                 <div className="image-preview-area-modern">
//                   <div className="preview-header-modern">
//                     <span>{imagePreviewUrls.length} image(s) selected</span>
//                     <button onClick={clearImages}>
//                       <FaTimes /> Clear
//                     </button>
//                   </div>
//                   <div className="preview-images-modern">
//                     {imagePreviewUrls.map((url, idx) => (
//                       <div key={idx} className="preview-image-wrapper-modern">
//                         <img src={url} alt={`Preview ${idx + 1}`} />
//                         <button
//                           className="remove-image-modern"
//                           onClick={() => removeSelectedImage(idx)}
//                         >
//                           <FaTimes />
//                         </button>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {/* Chat Input Area */}
//               <div className="message-input-area-modern">
//                 {isNegotiationPhase &&
//                   !negotiationDetails?.final_agreed_amount &&
//                   !hasPendingAgreement && (
//                     <button
//                       className="submit-agreement-btn-modern"
//                       onClick={() => setShowFinalAgreementModal(true)}
//                     >
//                       <FaHandshake /> Submit Final Agreement
//                     </button>
//                   )}

//                 {isArtisanSelected && !isChatDisabled && (
//                   <div className="message-type-selector-modern">
//                     <button
//                       className={`type-btn-modern ${messageType === 'chat' ? 'active' : ''}`}
//                       onClick={() => setMessageType('chat')}
//                     >
//                       💬 Chat
//                     </button>
//                     <button
//                       className={`type-btn-modern ${messageType === 'milestone' ? 'active' : ''}`}
//                       onClick={() => setMessageType('milestone')}
//                     >
//                       🎯 Milestone
//                     </button>
//                   </div>
//                 )}

//                 {isArtisanSelected && messageType === 'milestone' ? (
//                   <div className="milestone-inputs-modern">
//                     <input
//                       type="number"
//                       placeholder="Progress %"
//                       value={progressPercentage}
//                       onChange={(e) => setProgressPercentage(e.target.value)}
//                       className={`progress-input-modern ${isMilestoneComplete ? 'complete' : ''}`}
//                       min="0"
//                       max="100"
//                     />
//                     {isMilestoneComplete && (
//                       <div className="completion-notice-modern">
//                         <FaCheck className="completion-icon" />
//                         <span>
//                           🎉 This will mark the project as complete and notify
//                           the client about final payment!
//                         </span>
//                       </div>
//                     )}
//                     <textarea
//                       placeholder="Describe the milestone achieved..."
//                       value={milestoneNote}
//                       onChange={(e) => setMilestoneNote(e.target.value)}
//                       className="milestone-textarea-modern"
//                       rows={1}
//                     />
//                     <div className="milestone-actions-modern">
//                       <button
//                         className="attach-btn-modern"
//                         onClick={() => fileInputRef.current?.click()}
//                       >
//                         <FaImage />
//                       </button>
//                       <button
//                         onClick={sendMessage}
//                         disabled={
//                           !milestoneNote.trim() ||
//                           !progressPercentage ||
//                           isSending
//                         }
//                         className={`milestone-send-btn-modern ${isMilestoneComplete ? 'complete' : ''}`}
//                       >
//                         {isSending ? <FaClock /> : <FaPaperPlane />}
//                       </button>
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="input-wrapper-modern">
//                     <button
//                       className="attach-btn-modern"
//                       onClick={() => fileInputRef.current?.click()}
//                       disabled={isChatDisabled}
//                     >
//                       <FaImage />
//                     </button>
//                     <input
//                       type="text"
//                       placeholder={
//                         isChatDisabled ? 'Chat is closed' : 'Type a message...'
//                       }
//                       value={newMessage}
//                       onChange={(e) => setNewMessage(e.target.value)}
//                       onKeyPress={(e) => {
//                         if (
//                           e.key === 'Enter' &&
//                           !e.shiftKey &&
//                           !isChatDisabled
//                         ) {
//                           e.preventDefault();
//                           sendMessage();
//                         }
//                       }}
//                       className="message-input-modern"
//                       disabled={isChatDisabled}
//                     />
//                     <button
//                       onClick={sendMessage}
//                       disabled={
//                         isSending ||
//                         isChatDisabled ||
//                         (!isArtisanSelected &&
//                           !newMessage.trim() &&
//                           selectedImages.length === 0)
//                       }
//                       className="send-button-modern"
//                     >
//                       {isSending ? <FaClock /> : <FaPaperPlane />}
//                     </button>
//                   </div>
//                 )}

//                 <input
//                   type="file"
//                   ref={fileInputRef}
//                   style={{ display: 'none' }}
//                   accept="image/*"
//                   multiple
//                   onChange={handleImageSelect}
//                 />
//               </div>
//             </>
//           )}
//         </div>
//       </div>

//       {/* Submit Final Agreement Modal */}
//       <Modal
//         show={showFinalAgreementModal}
//         onHide={() => setShowFinalAgreementModal(false)}
//         centered
//         className="modal-modern"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Submit Final Agreement</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="modal-content-modern">
//             <p>
//               Submit the final agreed price for this project. The client will
//               need to accept it.
//             </p>
//             <div className="input-group-modern">
//               <label>Final Agreed Amount (KSh)</label>
//               <input
//                 type="number"
//                 placeholder="Enter final agreed amount"
//                 value={finalAgreementAmount}
//                 onChange={(e) => setFinalAgreementAmount(e.target.value)}
//               />
//             </div>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={() => setShowFinalAgreementModal(false)}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             onClick={handleSubmitFinalAgreement}
//             disabled={!finalAgreementAmount || isSubmittingFinalAgreement}
//           >
//             {isSubmittingFinalAgreement ? 'Submitting...' : 'Submit Agreement'}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Final Agreement Modal */}
//       <Modal
//         show={showEditFinalAgreementModal}
//         onHide={() => setShowEditFinalAgreementModal(false)}
//         centered
//         className="modal-modern edit-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>
//             <FaEdit /> Edit Final Agreement
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="modal-content-modern">
//             <p className="warning-text">
//               Current pending amount: KSh{' '}
//               {Number(
//                 negotiationDetails?.pending_final_amount || 0,
//               ).toLocaleString()}
//             </p>
//             <div className="input-group-modern">
//               <label>Corrected Amount (KSh)</label>
//               <input
//                 type="number"
//                 placeholder="Enter corrected amount"
//                 value={editFinalAgreementAmount}
//                 onChange={(e) => setEditFinalAgreementAmount(e.target.value)}
//               />
//             </div>
//             <div className="input-group-modern">
//               <label>Reason for correction (Optional)</label>
//               <textarea
//                 rows="3"
//                 placeholder="Explain why you're correcting the amount..."
//                 value={editAgreementNote}
//                 onChange={(e) => setEditAgreementNote(e.target.value)}
//               />
//             </div>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={() => setShowEditFinalAgreementModal(false)}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             onClick={handleEditFinalAgreement}
//             disabled={isEditingFinalAgreement || !editFinalAgreementAmount}
//           >
//             {isEditingFinalAgreement ? 'Updating...' : 'Update Agreement'}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Image Viewer Modal */}
//       <Modal
//         show={showImageViewer}
//         onHide={() => setShowImageViewer(false)}
//         centered
//         size="lg"
//         className="image-viewer-modal-modern"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>View Image</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="image-viewer-body-modern">
//           {selectedImageForView && (
//             <img
//               src={selectedImageForView}
//               alt="Full size"
//               className="full-image-modern"
//             />
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowImageViewer(false)}>
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             onClick={() => window.open(selectedImageForView, '_blank')}
//           >
//             Download
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default withAuth(ArtisanMessages, 'artisan');


import React, { useState, useEffect, useRef } from 'react';
import './artisanmessages.scss';
import withAuth from '../../auth/WithAuth';
import FurnitureNavbar from '../../../components/layout/Nav';
import { serverUrlAuth } from '../../../serverUrl';
import { toast } from 'react-toastify';
import {
  FaSearch,
  FaUserCircle,
  FaComments,
  FaPaperPlane,
  FaArrowLeft,
  FaClock,
  FaImage,
  FaCheck,
  FaHandshake,
  FaMoneyBillWave,
  FaTimes,
  FaFlag,
  FaEdit,
} from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const ArtisanMessages = () => {
  const location = useLocation();
 
  const queryParams = new URLSearchParams(location.search);
  const preselectedProposalId = queryParams.get('proposal');

  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSidebar, setShowSidebar] = useState(true);
  const [negotiationDetails, setNegotiationDetails] = useState(null);
  const [isArtisanSelected, setIsArtisanSelected] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(null);

  const [messageType, setMessageType] = useState('chat');
  const [progressPercentage, setProgressPercentage] = useState('');
  const [milestoneNote, setMilestoneNote] = useState('');

  const [selectedImages, setSelectedImages] = useState([]);
  const [imagePreviewUrls, setImagePreviewUrls] = useState([]);
  const fileInputRef = useRef(null);

  // Camera related state
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);
  const [capturedPhoto, setCapturedPhoto] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const [showFinalAgreementModal, setShowFinalAgreementModal] = useState(false);
  const [finalAgreementAmount, setFinalAgreementAmount] = useState('');
  const [isSubmittingFinalAgreement, setIsSubmittingFinalAgreement] =
    useState(false);

  const [showEditFinalAgreementModal, setShowEditFinalAgreementModal] =
    useState(false);
  const [editFinalAgreementAmount, setEditFinalAgreementAmount] = useState('');
  const [isEditingFinalAgreement, setIsEditingFinalAgreement] = useState(false);
  const [editAgreementNote, setEditAgreementNote] = useState('');

  const [showImageViewer, setShowImageViewer] = useState(false);
  const [selectedImageForView, setSelectedImageForView] = useState(null);

  const messagesEndRef = useRef(null);
  const messageIntervalRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const isPollingRef = useRef(false);

  // Camera functions
  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment', width: { ideal: 1280 }, height: { ideal: 720 } },
        audio: false
      });
      setCameraStream(stream);
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        await videoRef.current.play();
      }
      setShowCameraModal(true);
      setCapturedPhoto(null);
    } catch (err) {
      console.error('Error accessing camera:', err);
      if (err.name === 'NotAllowedError') {
        toast.error('Camera access denied. Please allow camera permissions.');
      } else if (err.name === 'NotFoundError') {
        toast.error('No camera found on this device.');
      } else {
        toast.error('Failed to open camera. Please try again.');
      }
    }
  };

  const capturePhoto = () => {
    if (videoRef.current && canvasRef.current) {
      const video = videoRef.current;
      const canvas = canvasRef.current;
      
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      
      const context = canvas.getContext('2d');
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      
      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], `photo-${Date.now()}.jpg`, { type: 'image/jpeg' });
          const previewUrl = URL.createObjectURL(blob);
          
          setCapturedPhoto({
            file: file,
            previewUrl: previewUrl
          });
        }
      }, 'image/jpeg', 0.9);
    }
  };

  const retakePhoto = () => {
    setCapturedPhoto(null);
    if (videoRef.current) {
      videoRef.current.play().catch(console.error);
    }
  };

  const saveCapturedPhoto = () => {
    if (capturedPhoto) {
      setSelectedImages(prev => [...prev, capturedPhoto.file]);
      setImagePreviewUrls(prev => [...prev, capturedPhoto.previewUrl]);
      setShowCameraModal(false);
      setCapturedPhoto(null);
      stopCamera();
      toast.success('Photo captured successfully!');
    }
  };

  const stopCamera = () => {
    if (cameraStream) {
      cameraStream.getTracks().forEach(track => track.stop());
      setCameraStream(null);
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
  };

  const markMessagesAsRead = async (projectId) => {
    if (!projectId) return;
    try {
      await serverUrlAuth.post(
        `/updates/mark-messages-as-read/${projectId}/mark-all-read/`,
      );
      const convResponse = await serverUrlAuth.get('negotiations/inbox/');
      setConversations(convResponse.data);
    } catch (err) {
      console.error('Error marking messages as read:', err);
    }
  };

  const fetchProposalDetails = async (proposalId) => {
    try {
      const response = await serverUrlAuth.get(
        `proposals/proposal-detail/${proposalId}/`,
      );
      return response.data;
    } catch (err) {
      console.error('Error fetching proposal details:', err);
      return null;
    }
  };

  const handleEditFinalAgreement = async () => {
    if (!editFinalAgreementAmount || editFinalAgreementAmount <= 0) {
      toast.error('Please enter a valid amount');
      return;
    }

    setIsEditingFinalAgreement(true);
    try {
      await serverUrlAuth.patch(
        `negotiations/submit-final-agreement/${negotiationDetails.id}/`,
        {
          final_agreed_amount: editFinalAgreementAmount,
        },
      );

      toast.success('Final agreement amount updated successfully!');
      setShowEditFinalAgreementModal(false);
      setEditFinalAgreementAmount('');
      setEditAgreementNote('');

      await fetchNegotiationDetails(selectedConversation.proposal);

      if (editAgreementNote.trim()) {
        await serverUrlAuth.post(
          `negotiations/proposal/${selectedConversation?.proposal}/messages/`,
          {
            message: `📝 Note about updated agreement: ${editAgreementNote}`,
          },
        );
      }

      await fetchMessages(currentProjectId);
    } catch (err) {
      console.error('Error updating final agreement:', err);
      toast.error('Failed to update final agreement');
    } finally {
      setIsEditingFinalAgreement(false);
    }
  };

  const fetchProjectStatus = async (projectId) => {
    if (!projectId) return false;
    try {
      const response = await serverUrlAuth.get(
        `projects/artisan-project/${projectId}/`,
      );
      if (response.data) {
        const isSelected =
          response.data.status === 'in-progress' ||
          response.data.status === 'completed';
        setIsArtisanSelected(isSelected);
        return isSelected;
      }
      return false;
    } catch (err) {
      console.error('Error fetching project status:', err);
      return false;
    }
  };

  const fetchConversations = async () => {
    try {
      const response = await serverUrlAuth.get('negotiations/inbox/');
      setConversations(response.data);

      if (preselectedProposalId && !selectedConversation) {
        let conversation = response.data.find(
          (c) => c.proposal?.toString() === preselectedProposalId,
        );

        if (conversation) {
          const projectId = conversation.proposal_details?.project;
          setCurrentProjectId(projectId);
          setSelectedConversation(conversation);
          setShowSidebar(false);

          await fetchProposalDetails(conversation.proposal);
          await fetchProjectStatus(projectId);
          await fetchNegotiationDetails(conversation.proposal);
          await fetchMessages(projectId);
          await markMessagesAsRead(projectId);
        } else {
          await fetchSingleConversation(preselectedProposalId);
        }
      }
    } catch (err) {
      console.error('Error fetching conversations:', err);
      toast.error('Failed to load conversations');
    } finally {
      setLoading(false);
    }
  };

  const fetchSingleConversation = async (proposalId) => {
    try {
      const response = await serverUrlAuth.get(
        `negotiations/proposal/${proposalId}/`,
      );
      const convData = response.data;
      const projectId = convData.proposal_details?.project;

      const newConversation = {
        id: convData.id,
        proposal: proposalId,
        project_id: projectId,
        project_title: convData.project_title,
        artisan_name: convData.artisan_name,
        client_name: convData.client_name,
        last_message_time: convData.created_at,
        unread_count: 0,
      };

      setCurrentProjectId(projectId);
      setSelectedConversation(newConversation);
      setShowSidebar(false);
      setNegotiationDetails(convData);

      await fetchProposalDetails(proposalId);
      await fetchProjectStatus(projectId);
      await fetchMessages(projectId);
      await markMessagesAsRead(projectId);
    } catch (err) {
      console.error('Error fetching single conversation:', err);
      toast.error('Could not open conversation');
    }
  };

  const fetchMessages = async (projectId, isPolling = false) => {
    if (!projectId) return;

    if (!isPolling) setLoadingMessages(true);
    try {
      const response = await serverUrlAuth.get(
        `/updates/messages/${projectId}/`,
      );
      setMessages(response.data);
      scrollToBottom();
    } catch (err) {
      console.error('Error fetching messages:', err);
    } finally {
      if (!isPolling) setLoadingMessages(false);
    }
  };

  const fetchNegotiationDetails = async (proposalId) => {
    try {
      const response = await serverUrlAuth.get(
        `negotiations/proposal/${proposalId}/`,
      );
      setNegotiationDetails(response.data);
    } catch (err) {
      console.error('Error fetching negotiation details:', err);
    }
  };

  const handleImageSelect = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter((file) => file.type.startsWith('image/'));
    const newImages = [...selectedImages, ...validFiles];
    const newPreviews = [
      ...imagePreviewUrls,
      ...validFiles.map((file) => URL.createObjectURL(file)),
    ];
    setSelectedImages(newImages);
    setImagePreviewUrls(newPreviews);
  };

  const removeSelectedImage = (index) => {
    URL.revokeObjectURL(imagePreviewUrls[index]);
    setSelectedImages(selectedImages.filter((_, i) => i !== index));
    setImagePreviewUrls(imagePreviewUrls.filter((_, i) => i !== index));
  };

  const clearImages = () => {
    imagePreviewUrls.forEach((url) => URL.revokeObjectURL(url));
    setSelectedImages([]);
    setImagePreviewUrls([]);
  };

  const sendMessage = async () => {
    if (isArtisanSelected) {
      if (messageType === 'milestone') {
        if (!milestoneNote.trim()) {
          toast.error('Please add a note for the milestone');
          return;
        }
        if (
          !progressPercentage ||
          progressPercentage < 0 ||
          progressPercentage > 100
        ) {
          toast.error('Please enter a valid progress percentage (0-100)');
          return;
        }
      } else {
        if (!newMessage.trim() && selectedImages.length === 0) {
          toast.error('Please enter a message or attach an image');
          return;
        }
      }
    } else {
      if (!newMessage.trim() && selectedImages.length === 0) return;
    }

    setIsSending(true);

    try {
      let response;

      if (isArtisanSelected && currentProjectId) {
        const formData = new FormData();
        const isMilestoneComplete =
          messageType === 'milestone' && parseInt(progressPercentage) === 100;

        formData.append('type', messageType);

        if (messageType === 'milestone') {
          formData.append('progress_percentage', progressPercentage);
          formData.append('note', milestoneNote);
        } else {
          formData.append('message', newMessage.trim() || '📷 Image attached');
        }

        selectedImages.forEach((image) => {
          formData.append('uploaded_images', image);
        });

        response = await serverUrlAuth.post(
          `/updates/post-updates/${currentProjectId}/`,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          },
        );

        if (isMilestoneComplete) {
          const paymentMessage = `🎉 Your product is ready. To proceed with delivery, kindly complete the final payment. Delivery will begin as soon as your payment is confirmed.`;

          await serverUrlAuth.post(
            `/updates/post-updates/${currentProjectId}/`,
            {
              type: 'chat',
              message: paymentMessage,
            },
            {
              headers: { 'Content-Type': 'application/json' },
            },
          );

          toast.success(
            '🎉 Project marked as complete! Payment notification sent to client.',
          );
        }

        setProgressPercentage('');
        setMilestoneNote('');
      } else {
        const formData = new FormData();
        formData.append('message', newMessage.trim() || '📷 Image attached');
        selectedImages.forEach((image) => {
          formData.append('images', image);
        });

        response = await serverUrlAuth.post(
          `negotiations/proposal/${selectedConversation.proposal}/messages/`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } },
        );
      }

      if (response.data) {
        setMessages((prev) => [...prev, response.data]);
        setNewMessage('');
        clearImages();
        scrollToBottom();

        const convResponse = await serverUrlAuth.get('negotiations/inbox/');
        setConversations(convResponse.data);
      }
    } catch (err) {
      console.error('Failed to send message:', err);
      toast.error('Failed to send message.');
    } finally {
      setIsSending(false);
    }
  };

  const handleSubmitFinalAgreement = async () => {
    if (!finalAgreementAmount || !selectedConversation || !negotiationDetails)
      return;

    setIsSubmittingFinalAgreement(true);
    try {
      await serverUrlAuth.patch(
        `negotiations/submit-final-agreement/${negotiationDetails.id}/`,
        {
          final_agreed_amount: finalAgreementAmount,
        },
      );

      toast.success(
        `Final agreement submitted! Waiting for client acceptance.`,
      );
      setShowFinalAgreementModal(false);
      setFinalAgreementAmount('');
      await fetchNegotiationDetails(selectedConversation.proposal);
      await fetchMessages(currentProjectId);
    } catch (err) {
      console.error('Error submitting final agreement:', err);
      toast.error('Failed to submit final agreement');
    } finally {
      setIsSubmittingFinalAgreement(false);
    }
  };

  const handleSelectConversation = async (conversation) => {
    const projectId = conversation.proposal_details?.project;
    setCurrentProjectId(projectId);
    setSelectedConversation(conversation);

    await fetchProposalDetails(conversation.proposal);
    await fetchProjectStatus(projectId);
    await fetchNegotiationDetails(conversation.proposal);
    await fetchMessages(projectId);
    await markMessagesAsRead(projectId);
    setShowSidebar(false);
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      if (messagesContainerRef.current) {
        messagesContainerRef.current.scrollTop =
          messagesContainerRef.current.scrollHeight;
      }
    }, 100);
  };

  const startPolling = () => {
    if (messageIntervalRef.current) clearInterval(messageIntervalRef.current);

    messageIntervalRef.current = setInterval(async () => {
      if (selectedConversation && currentProjectId && !isPollingRef.current) {
        isPollingRef.current = true;
        try {
          await fetchMessages(currentProjectId, true);
          const convResponse = await serverUrlAuth.get('negotiations/inbox/');
          setConversations(convResponse.data);
          scrollToBottom();
        } catch (error) {
          console.error('Polling error:', error);
        } finally {
          isPollingRef.current = false;
        }
      }
    }, 5000);
  };

  const stopPolling = () => {
    if (messageIntervalRef.current) {
      clearInterval(messageIntervalRef.current);
      messageIntervalRef.current = null;
    }
  };

  const filteredConversations = conversations.filter(
    (conv) =>
      conv.client_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      conv.project_title?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const now = new Date();
    const diff = now - date;
    const hours = Math.floor(diff / (1000 * 60 * 60));

    if (hours < 1) {
      const mins = Math.floor(diff / (1000 * 60));
      return mins === 0 ? 'Just now' : `${mins} min ago`;
    } else if (hours < 24) {
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    } else if (hours < 48) {
      return 'Yesterday';
    } else {
      return date.toLocaleDateString();
    }
  };

  const formatMessageTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const getUnreadCount = (conversation) => conversation.unread_count || 0;
  const getDisplayName = (conversation) => conversation.client_name;

  useEffect(() => {
    fetchConversations();
    return () => stopPolling();
  }, []);

  useEffect(() => {
    if (selectedConversation && currentProjectId) {
      startPolling();
    } else {
      stopPolling();
    }
    return () => stopPolling();
  }, [selectedConversation, currentProjectId]);

  useEffect(() => {
    return () => {
      stopCamera();
      imagePreviewUrls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, []);

  const hasPendingAgreement =
    negotiationDetails?.pending_final_amount &&
    !negotiationDetails?.final_agreed_amount;
  const isChatDisabled = negotiationDetails?.is_closed === true;
  const isNegotiationPhase = !isArtisanSelected && !isChatDisabled;
  const isMilestoneComplete =
    messageType === 'milestone' && parseInt(progressPercentage) === 100;

  if (loading) {
    return (
      <div className="modern-dashboard">
        <div className="dashboard-loader">
          <div className="wooden-spinner"></div>
          <p>Loading conversations...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="modern-dashboard">
      <FurnitureNavbar />

      <div className="messages-container-modern">
        {/* Sidebar */}
        <div
          className={`conversations-sidebar-modern ${showSidebar ? 'open' : 'closed'}`}
        >
          <div className="sidebar-header-modern">
            <div className="search-bar-modern">
              <FaSearch className="search-icon-modern" />
              <input
                type="text"
                placeholder="Search clients..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          <div className="conversations-list-modern">
            {filteredConversations.length === 0 ? (
              <div className="empty-state-modern">
                <div className="empty-icon-modern">💬</div>
                <h4>No conversations yet</h4>
                <p>When clients message you, they'll appear here.</p>
              </div>
            ) : (
              filteredConversations.map((conv) => {
                const unreadCount = getUnreadCount(conv);
                return (
                  <div
                    key={conv.id}
                    className={`conversation-item-modern ${selectedConversation?.id === conv.id ? 'active' : ''}`}
                    onClick={() => handleSelectConversation(conv)}
                  >
                    <div className="avatar-modern">
                      <FaUserCircle />
                    </div>
                    <div className="conversation-info-modern">
                      <div className="conversation-header-modern">
                        <h4>{getDisplayName(conv)}</h4>
                        <span className="timestamp-modern">
                          {formatTime(conv.last_message_time)}
                        </span>
                      </div>
                      <div className="conversation-preview-modern">
                        <p className="project-title-modern">
                          {conv.project_title}
                        </p>
                      </div>
                    </div>
                    {unreadCount > 0 && (
                      <div className="unread-badge-modern">{unreadCount}</div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* Main Chat Area */}
        <div className="chat-area-modern">
          {!selectedConversation ? (
            <div className="no-conversation-selected-modern">
              <div className="no-chat-icon-modern">
                <FaComments />
              </div>
              <h3>Select a conversation</h3>
              <p>Choose a chat from the list to start messaging</p>
              <button
                className="back-to-chats-btn-modern"
                onClick={() => setShowSidebar(true)}
              >
                Back to Chats
              </button>
            </div>
          ) : (
            <>
              <div className="chat-header-modern">
                <button
                  className="back-button-modern"
                  onClick={() => {
                    setShowSidebar(true);
                    setSelectedConversation(null);
                  }}
                >
                  <FaArrowLeft />
                </button>
                <div className="chat-user-info-modern">
                  <div className="user-avatar-modern">
                    <FaUserCircle />
                  </div>
                  <div className="user-details-modern">
                    <h3>{getDisplayName(selectedConversation)}</h3>
                    <p className="project-context-modern">
                      Project: {selectedConversation.project_title}
                    </p>
                  </div>
                </div>
              </div>

              {/* Status Banner */}
              {isArtisanSelected ? (
                <div className="status-banner-modern success">
                  <FaCheck className="status-icon" />
                  <span>Project In Progress</span>
                  <small>
                    Send updates and milestones to keep the client informed
                  </small>
                </div>
              ) : (
                negotiationDetails && (
                  <div className="status-banner-modern info">
                    {negotiationDetails.final_agreed_amount ? (
                      <>
                        <FaHandshake />
                        <span>
                          Price Agreed: KSh{' '}
                          {Number(
                            negotiationDetails.final_agreed_amount,
                          ).toLocaleString()}
                        </span>
                      </>
                    ) : negotiationDetails.pending_final_amount ? (
                      <>
                        <FaMoneyBillWave />
                        <span>
                          Pending: KSh{' '}
                          {Number(
                            negotiationDetails.pending_final_amount,
                          ).toLocaleString()}
                        </span>
                        <button
                          className="edit-agreement-btn-modern"
                          onClick={() => {
                            setEditFinalAgreementAmount(
                              negotiationDetails.pending_final_amount,
                            );
                            setShowEditFinalAgreementModal(true);
                          }}
                        >
                          <FaEdit /> Edit
                        </button>
                      </>
                    ) : (
                      <>
                        <FaComments />
                        <span>Negotiating - Discuss price with the client</span>
                      </>
                    )}
                  </div>
                )
              )}

              {/* Messages Area */}
              <div className="messages-area-modern" ref={messagesContainerRef}>
                {loadingMessages && messages.length === 0 ? (
                  <div className="loading-messages-modern">
                    <div className="spinner-modern"></div>
                    <p>Loading messages...</p>
                  </div>
                ) : messages.length === 0 ? (
                  <div className="no-messages-modern">
                    <div className="no-messages-icon-modern">💬</div>
                    <p>No messages yet</p>
                    <small>Send a message to start the conversation</small>
                  </div>
                ) : (
                  messages.map((msg, index) => {
                    const isSent = msg.sender_role === 'artisan';
                    const isMilestone = msg.type === 'milestone';
                    const showDate =
                      index === 0 ||
                      (messages[index - 1] &&
                        new Date(
                          msg.timestamp || msg.created_at,
                        ).toDateString() !==
                          new Date(
                            messages[index - 1].timestamp ||
                              messages[index - 1].created_at,
                          ).toDateString());

                    return (
                      <React.Fragment key={msg.id}>
                        {showDate && (
                          <div className="date-divider-modern">
                            <span>
                              {new Date(
                                msg.timestamp || msg.created_at,
                              ).toLocaleDateString(undefined, {
                                weekday: 'long',
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                              })}
                            </span>
                          </div>
                        )}
                        <div
                          className={`message-bubble-modern ${isSent ? 'sent' : 'received'}`}
                        >
                          <div className="message-content-modern">
                            {isMilestone ? (
                              <div className="milestone-update-modern">
                                <div className="milestone-header-modern">
                                  <FaFlag className="milestone-icon-modern" />
                                  <span className="milestone-label-modern">
                                    Milestone Update
                                  </span>
                                </div>
                                <div className="progress-section-modern">
                                  <div className="progress-info-modern">
                                    <span>
                                      Progress: {msg.progress_percentage}%
                                    </span>
                                  </div>
                                  <div className="progress-bar-container-modern">
                                    <div
                                      className="progress-fill-modern"
                                      style={{
                                        width: `${msg.progress_percentage}%`,
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="milestone-note-modern">
                                  {msg.note}
                                </div>
                              </div>
                            ) : (
                              <p>{msg.message}</p>
                            )}
                            {msg.offer && (
                              <div className="offer-bubble-modern">
                                💰 Price Proposal: KSh{' '}
                                {Number(msg.offer).toLocaleString()}
                              </div>
                            )}
                            {msg.images && msg.images.length > 0 && (
                              <div className="message-images-modern">
                                {msg.images.map((img, imgIndex) => (
                                  <img
                                    key={imgIndex}
                                    src={img.image_url || img.image}
                                    alt="Attachment"
                                    className="message-image-modern"
                                    onClick={() => {
                                      setSelectedImageForView(
                                        img.image_url || img.image,
                                      );
                                      setShowImageViewer(true);
                                    }}
                                  />
                                ))}
                              </div>
                            )}
                          </div>
                          <div className="message-meta-modern">
                            <span className="message-time-modern">
                              {formatMessageTime(
                                msg.created_at || msg.timestamp,
                              )}
                            </span>
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })
                )}
                <div ref={messagesEndRef} />
              </div>

              {/* Image Preview Area */}
              {imagePreviewUrls.length > 0 && (
                <div className="image-preview-area-modern">
                  <div className="preview-header-modern">
                    <span>{imagePreviewUrls.length} image(s) selected</span>
                    <button onClick={clearImages}>
                      <FaTimes /> Clear
                    </button>
                  </div>
                  <div className="preview-images-modern">
                    {imagePreviewUrls.map((url, idx) => (
                      <div key={idx} className="preview-image-wrapper-modern">
                        <img src={url} alt={`Preview ${idx + 1}`} />
                        <button
                          className="remove-image-modern"
                          onClick={() => removeSelectedImage(idx)}
                        >
                          <FaTimes />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Chat Input Area */}
              <div className="message-input-area-modern">
                {isNegotiationPhase &&
                  !negotiationDetails?.final_agreed_amount &&
                  !hasPendingAgreement && (
                    <button
                      className="submit-agreement-btn-modern"
                      onClick={() => setShowFinalAgreementModal(true)}
                    >
                      <FaHandshake /> Submit Final Agreement
                    </button>
                  )}

                {isArtisanSelected && !isChatDisabled && (
                  <div className="message-type-selector-modern">
                    <button
                      className={`type-btn-modern ${messageType === 'chat' ? 'active' : ''}`}
                      onClick={() => setMessageType('chat')}
                    >
                      💬 Chat
                    </button>
                    <button
                      className={`type-btn-modern ${messageType === 'milestone' ? 'active' : ''}`}
                      onClick={() => setMessageType('milestone')}
                    >
                      🎯 Milestone
                    </button>
                  </div>
                )}

                {isArtisanSelected && messageType === 'milestone' ? (
                  <div className="milestone-inputs-modern">
                    <input
                      type="number"
                      placeholder="Progress %"
                      value={progressPercentage}
                      onChange={(e) => setProgressPercentage(e.target.value)}
                      className={`progress-input-modern ${isMilestoneComplete ? 'complete' : ''}`}
                      min="0"
                      max="100"
                    />
                    {isMilestoneComplete && (
                      <div className="completion-notice-modern">
                        <FaCheck className="completion-icon" />
                        <span>
                          🎉 This will mark the project as complete and notify
                          the client about final payment!
                        </span>
                      </div>
                    )}
                    <textarea
                      placeholder="Describe the milestone achieved..."
                      value={milestoneNote}
                      onChange={(e) => setMilestoneNote(e.target.value)}
                      className="milestone-textarea-modern"
                      rows={1}
                    />
                    <div className="milestone-actions-modern">
                      <button
                        className="attach-btn-modern"
                        onClick={() => fileInputRef.current?.click()}
                      >
                        <FaImage />
                      </button>
                      <button
                        onClick={sendMessage}
                        disabled={
                          !milestoneNote.trim() ||
                          !progressPercentage ||
                          isSending
                        }
                        className={`milestone-send-btn-modern ${isMilestoneComplete ? 'complete' : ''}`}
                      >
                        {isSending ? <FaClock /> : <FaPaperPlane />}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="input-wrapper-modern">
                    <div className="attach-options-modern">
                      <button
                        className="attach-btn-modern"
                        onClick={() => fileInputRef.current?.click()}
                        disabled={isChatDisabled}
                        title="Upload from gallery"
                      >
                        <FaImage />
                      </button>
                      <button
                        className="camera-btn-modern"
                        onClick={startCamera}
                        disabled={isChatDisabled}
                        title="Take a photo"
                      >
                        📷
                      </button>
                    </div>
                    <input
                      type="text"
                      placeholder={
                        isChatDisabled ? 'Chat is closed' : 'Type a message...'
                      }
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                      onKeyPress={(e) => {
                        if (
                          e.key === 'Enter' &&
                          !e.shiftKey &&
                          !isChatDisabled
                        ) {
                          e.preventDefault();
                          sendMessage();
                        }
                      }}
                      className="message-input-modern"
                      disabled={isChatDisabled}
                    />
                    <button
                      onClick={sendMessage}
                      disabled={
                        isSending ||
                        isChatDisabled ||
                        (!isArtisanSelected &&
                          !newMessage.trim() &&
                          selectedImages.length === 0)
                      }
                      className="send-button-modern"
                    >
                      {isSending ? <FaClock /> : <FaPaperPlane />}
                    </button>
                  </div>
                )}

                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                  accept="image/*"
                  multiple
                  onChange={handleImageSelect}
                />
              </div>
            </>
          )}
        </div>
      </div>

      {/* Camera Modal */}
      <Modal
        show={showCameraModal}
        onHide={() => {
          setShowCameraModal(false);
          stopCamera();
          setCapturedPhoto(null);
        }}
        centered
        size="lg"
        className="camera-modal-modern"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <span className="camera-modal-title">📷 Take a Photo</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="camera-body-modern">
          <div className="camera-container-modern">
            {!capturedPhoto ? (
              <>
                <video
                  ref={videoRef}
                  className="camera-video-modern"
                  autoPlay
                  playsInline
                  muted
                />
                <canvas ref={canvasRef} style={{ display: 'none' }} />
                <div className="camera-controls-modern">
                  <button
                    className="capture-btn-modern"
                    onClick={capturePhoto}
                  >
                    <div className="capture-circle-modern" />
                  </button>
                  <button
                    className="close-camera-btn-modern"
                    onClick={() => {
                      setShowCameraModal(false);
                      stopCamera();
                    }}
                  >
                    <FaTimes /> Close
                  </button>
                </div>
              </>
            ) : (
              <div className="captured-preview-modern">
                <img
                  src={capturedPhoto.previewUrl}
                  alt="Captured"
                  className="captured-image-modern"
                />
                <div className="captured-controls-modern">
                  <button
                    className="retake-btn-modern"
                    onClick={retakePhoto}
                  >
                    🔄 Retake
                  </button>
                  <button
                    className="save-photo-btn-modern"
                    onClick={saveCapturedPhoto}
                  >
                    <FaCheck /> Use Photo
                  </button>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowCameraModal(false);
              stopCamera();
              setCapturedPhoto(null);
            }}
          >
            Cancel
          </Button>
          {capturedPhoto && (
            <Button
              variant="primary"
              onClick={saveCapturedPhoto}
            >
              Save Photo
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Submit Final Agreement Modal */}
      <Modal
        show={showFinalAgreementModal}
        onHide={() => setShowFinalAgreementModal(false)}
        centered
        className="modal-modern"
      >
        <Modal.Header closeButton>
          <Modal.Title>Submit Final Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-content-modern">
            <p>
              Submit the final agreed price for this project. The client will
              need to accept it.
            </p>
            <div className="input-group-modern">
              <label>Final Agreed Amount (KSh)</label>
              <input
                type="number"
                placeholder="Enter final agreed amount"
                value={finalAgreementAmount}
                onChange={(e) => setFinalAgreementAmount(e.target.value)}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowFinalAgreementModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmitFinalAgreement}
            disabled={!finalAgreementAmount || isSubmittingFinalAgreement}
          >
            {isSubmittingFinalAgreement ? 'Submitting...' : 'Submit Agreement'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Final Agreement Modal */}
      <Modal
        show={showEditFinalAgreementModal}
        onHide={() => setShowEditFinalAgreementModal(false)}
        centered
        className="modal-modern edit-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaEdit /> Edit Final Agreement
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-content-modern">
            <p className="warning-text">
              Current pending amount: KSh{' '}
              {Number(
                negotiationDetails?.pending_final_amount || 0,
              ).toLocaleString()}
            </p>
            <div className="input-group-modern">
              <label>Corrected Amount (KSh)</label>
              <input
                type="number"
                placeholder="Enter corrected amount"
                value={editFinalAgreementAmount}
                onChange={(e) => setEditFinalAgreementAmount(e.target.value)}
              />
            </div>
            <div className="input-group-modern">
              <label>Reason for correction (Optional)</label>
              <textarea
                rows="3"
                placeholder="Explain why you're correcting the amount..."
                value={editAgreementNote}
                onChange={(e) => setEditAgreementNote(e.target.value)}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowEditFinalAgreementModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleEditFinalAgreement}
            disabled={isEditingFinalAgreement || !editFinalAgreementAmount}
          >
            {isEditingFinalAgreement ? 'Updating...' : 'Update Agreement'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Image Viewer Modal */}
      <Modal
        show={showImageViewer}
        onHide={() => setShowImageViewer(false)}
        centered
        size="lg"
        className="image-viewer-modal-modern"
      >
        <Modal.Header closeButton>
          <Modal.Title>View Image</Modal.Title>
        </Modal.Header>
        <Modal.Body className="image-viewer-body-modern">
          {selectedImageForView && (
            <img
              src={selectedImageForView}
              alt="Full size"
              className="full-image-modern"
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowImageViewer(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => window.open(selectedImageForView, '_blank')}
          >
            Download
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default withAuth(ArtisanMessages, 'artisan');